// Routes du personnel (M11, lot L5-A), raccordées dans Application.tsx par une seule ligne. Les chemins
// fixes précèdent la fiche d'agent.
import type { RouteObject } from 'react-router';
import { PageAgent } from './PageAgent';
import { PageConges } from './PageConges';
import { PageEvaluations } from './PageEvaluations';
import { PageFormations } from './PageFormations';
import { PageMonEspace } from './PageMonEspace';
import { PagePersonnel } from './PagePersonnel';
import { PagePresences } from './PagePresences';

export const routesPersonnel: RouteObject[] = [
  { path: '/personnel', element: <PagePersonnel /> },
  { path: '/personnel/conges', element: <PageConges /> },
  { path: '/personnel/presences', element: <PagePresences /> },
  { path: '/personnel/formations', element: <PageFormations /> },
  { path: '/personnel/evaluations', element: <PageEvaluations /> },
  { path: '/personnel/moi', element: <PageMonEspace /> },
  { path: '/personnel/agents/:id', element: <PageAgent /> },
];
